import { render, staticRenderFns } from "./SecaoSaudeDoencaCronica.vue?vue&type=template&id=0b5f53d2&scoped=true"
import script from "./SecaoSaudeDoencaCronica.vue?vue&type=script&lang=js"
export * from "./SecaoSaudeDoencaCronica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f53d2",
  null
  
)

export default component.exports